import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RefundPolicy = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/v1/legal/refund-policy')
      .then((r) => r.json())
      .then((d) => { setData(d); setLoading(false); })
      .catch(() => { setError('Failed to load refund policy.'); setLoading(false); });
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        {loading && <div className="legal-loading">Loading…</div>}
        {error && <div className="legal-error">{error}</div>}

        {data && (
          <>
            <div className="legal-header">
              <h1 className="legal-title">{data.title}</h1>
              <p className="legal-meta">
                {data.company} · Last updated: {data.last_updated}
              </p>
            </div>

            <div className="legal-body">
              {data.sections.map((s, i) => (
                <div key={i} className="legal-section">
                  <h2 className="legal-section-heading">{s.heading}</h2>
                  <p className="legal-section-body">{s.body}</p>
                </div>
              ))}
            </div>

            <div className="legal-footer">
              <p>
                Refund requests? Email{' '}
                <a href="mailto:support@aiviora.online">support@aiviora.online</a>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RefundPolicy;
